import InHouseIndex from "@/views/in-house/InHouseIndex.vue";

const inHouse = [
    {
        path: '/in-house',
        name: 'inHouse',
        component: InHouseIndex
    }
]

export default inHouse;